import Http from "../../Http";
import { BASE_URL } from "../../Helper";

export const createOrganization = async (payload) => {
  try {
    const { data } = await Http.post(`${BASE_URL}organization/v1`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateOrganization = async (payload) => {
  try {
    const { data } = await Http.post(`${BASE_URL}organization/v1`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getOrganizations = async (params) => {
  try {
    const { data } = await Http.get(`${BASE_URL}organization/v1`, {
      params: {
        searchTerm: params.searchTerm || "",
        organizationIds: params.organizationIds || "",
        pageNo: params.pageNo || 1,
        recordsPerPage: params.recordsPerPage || 10,
        isActive: params.isActive ?? "",
      },
    });

    return data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const exportOrganizationReport = ({
  searchTerm = "",
  organizationIds = "",
  // isActive = "",
} = {}) => {
  return async () => {
    try {
      const params = new URLSearchParams({
        searchTerm,
        organizationIds,
        // isActive,
      });
      const response = await Http.get(
        `${BASE_URL}organization/export?${params.toString()}`,
        {
          responseType: "blob",
        },
      );

      return response;
    } catch (error) {
      throw error;
    }
  };
};
